function Survey(config) {
  const self = this;
  const renderer = require('Renderer');
  let activeQuestion;

  self.init = function () {
    activeQuestion = null
    return {}
  }

  self.done = function (urlParams) {
    $.get('/survey').then(nextQuestion);

    const form = $('#survey-form')
    form.on('change click', '#survey-risk-slider', function(e) {
      let riskAnswer = $(e.target).val()
      const graph = $('#risk-slider-graph')
      if (riskAnswer > 0) $(e.target).removeClass('handle-hide')
      graph.attr('src', 'assets/img/survey/' + riskAnswer + '-min.png')
      checkNextAvailable()
    });

    form.on('change', '#survey-honest,#survey-understand,[name=chooseIndex]', function() {
      let finishSurveyButton = $('.finish-survey')
      const firstChecked = $('#survey-understand').is(':checked')
      const secondChecked = $('#survey-honest').is(':checked')
      const chooseIndexChecked = $('[name=chooseIndex]:checked')
      finishSurveyButton.toggleClass('disabled', !firstChecked || !secondChecked || !chooseIndexChecked)
    });

    form.on('click', '#print-questionnaire', function(e) {
      e.preventDefault();
      return $(e.target).hasClass('disabled') ? false : window.print()
    })

    form.on('DOMSubtreeModified', '#question', checkNextAvailable);
    form.on('change', '.survey-answer', checkNextAvailable);
    form.on('change keyup', '.survey-input', checkNextAvailable);
    form.on('change', '.survey-accept', checkNextAvailable);

    form.on('click', '#previous-question', function(e) {
      e.preventDefault();
      $.get('/survey/back').then(nextQuestion)
    })

    form.on('click', '#recommendations', function(e) {
      e.preventDefault();
      $.post('/survey/submit', {}).then((response) => submit(response, urlParams))
    })

    form.on('click', '#next-question', function(e) {
      e.preventDefault();
      sendAnswer($('#survey-risk-slider, .survey-answer:checked').val())
    })
  }

  function checkNextAvailable() {
    let nextBtn = $('#next-question')
    nextBtn.addClass('disabled')
    const surveySlider = $('#survey-risk-slider')

    let surveyRadioAnswerChecked = $('.survey-answer:checked').length === 1
    let surveySliderSelected = surveySlider.val() > 0 && !surveySlider.hasClass('handle-hide')
    let surveyCheckboxSelected = $('.survey-accept').is(':checked')

    if (areAllTextFieldsValid() || surveyRadioAnswerChecked || surveySliderSelected || surveyCheckboxSelected) {
      nextBtn.removeClass('disabled')
    }
  }

  function areAllTextFieldsValid() {
    const textInputs = $('.survey-input')
    let areAllTextFieldsValid = textInputs.length > 0
    textInputs.each((_, input) => {
      areAllTextFieldsValid = areAllTextFieldsValid && !!input.value && !!input.value.match(new RegExp(input.getAttribute('data-regex')))
    })
    return areAllTextFieldsValid
  }

  function sendAnswer(answer) {
    $.post('/survey/answer/' + activeQuestion.id, {
      question: activeQuestion.id,
      answer: answer,
      answers: JSON.stringify($.map($('#survey-form .survey-input'), input => ({
        question: input.name,
        answer: input.value
      })))
    }).then(nextQuestion)
  }

  function submit(response, urlParams) {
    $('#recommendations').addClass('d-none')

    if (window.session) {
      session.setQuestionnaireStatus(response.status)
    }

    if (response.status === 'FINISHED') {
      let progressbar = $('#survey-progressbar')
      progressbar.width('100%');
      progressbar.attr('aria-valuenow', 10)

      const interest = response.luminorInterestPercentage
      const stocks = 100 - interest
      $("#question").html(renderer.template('survey-result')({
        moreThan15Years: response.yearsToPension > 15,
        nextYears: response.yearsToPension - 15,
        answers: response.answers,
        interest: interest,
        stocks: stocks,
        loggedIn: window.session !== undefined,
        documentDate: new Date().toLocaleDateString("et-EE", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
        person: response['person']
      }));

      $(document).on('click', '#invest', function(e) {
        e.preventDefault();
        const stocksFund = $('[name=chooseIndex]:checked').val() === 'true' ? 'EE3600001798' : 'EE3600098422'
        location.href = '#third-pillar-select' +
          '?selectedStrategy=' + stocks + stocksFund + interest + 'EE3600109369'
      })
    }
  }

  function nextQuestion(response) {
    activeQuestion = response.question
    let recButton = $('#recommendations')
    let prevButton = $('#previous-question')
    let nextButton = $('#next-question')

    if (window.session) {
      session.setQuestionnaireStatus(response.status)
    }

    response.status === 'WAITING' ? prevButton.addClass('d-none') : prevButton.removeClass('d-none')

    if (response.status === 'FINISHED') {
      nextButton.addClass('d-none');
      prevButton.addClass('d-none');
      recButton.removeClass('d-none')
    }
    else if (response.status === 'CANCELED') {
      nextButton.addClass('d-none');
      prevButton.addClass('d-none');
      recButton.addClass('d-none')

      $("#question").html(renderer.template('survey-canceled')({
        loggedIn: window.session !== undefined
      }));

      return
    }
    else {
      recButton.addClass('d-none')
      nextButton.removeClass('d-none')
    }

    if (activeQuestion) {
      const processedQuestions = activeQuestion.id.replace('q', '')
      const progressbar = $('#survey-progressbar')
      progressbar.width((processedQuestions * 10) + '%')
      progressbar.attr('aria-valuenow', processedQuestions)

      $("#question").html(renderer.template(activeQuestion.template)({
        question: activeQuestion.question,
        options: activeQuestion.options,
        loggedIn: window.session !== undefined,
        inEstonian: config.language === 'et',
        person: response['person']
      }));
    }
  }
}